import type { IsoAndUnixTimestamp } from "@@/shared/date-time/iso-and-unix";
import type { TimeRange } from "@@/shared/date-time/time-range";
import type { OrderId } from "@@/shared/orders/order-id";
import type { CustomerId } from "@@/shared/users/customer-id";
import type { UserId } from "@@/shared/users/user-id";
import type { Except } from "type-fest";
import type { ResourceReservation } from "../resources/resource-reservation";
import type { BookableSessionId } from "../sessions/bookable-session-id";
import type { ReservationId} from "./reservation-id";
import { reservationIdFactory } from "./reservation-id";

type ReservationExtended = {
    readonly _id: ReservationId;
    readonly _type: "RESERVATION_EXTENDED";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly timeRange: TimeRange;
    readonly orderId?: OrderId;
    readonly orderGroupReference?: string;
    readonly customerId: UserId | CustomerId;
    readonly sessionId?: BookableSessionId;
    /** @deprecated */
    readonly paymentStatus:
        | "BETALD"
        | "OBETALD"
        | "KASSABETALD"
        | "ÅTERBETALD"
        | "EJ KUNDORDER";
    readonly confirmed: boolean;
    readonly checkedIn: boolean;
    readonly mainQuantity: number;
    readonly resourceReservations: ResourceReservation[];
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isReservationExtended = (item: any): item is ReservationExtended => {
    return item._type === "RESERVATION_EXTENDED";
};

type CreateParams = Except<ReservationExtended, "_type" | "_id">;
const reservationExtendedFactory = (
    params: CreateParams,
): ReservationExtended => {
    return {
        ...params,
        _type: "RESERVATION_EXTENDED",
        _id: reservationIdFactory(),
    };
};
export { isReservationExtended, reservationExtendedFactory };
export type { ReservationExtended };
